import { InfoCircleOutlined } from "@ant-design/icons";
import { Input, Tooltip } from "antd";
import React from "react";

function AppInput({
  type,
  label,
  value,
  placeholder,
  onChange,
  errors,
  requerd,
  disabled,
  maxLength,
  showInfo = false,
  infoMessage = "",
  min,
  max,
}) {
  return (
    <div className="input-box">
      <label>
        {label} <i style={{ color: "red" }}>{requerd}</i>
      </label>
      {showInfo && (
        <Tooltip title={infoMessage} placement="right">
          <InfoCircleOutlined
            style={{
              marginLeft: 8,
              color: "red",
              fontSize: 12,
              cursor: "pointer",
            }}
          />
        </Tooltip>
      )}
      <Input
        disabled={disabled}
        type={type}
        value={value}
        placeholder={placeholder}
        onChange={onChange}
        style={{ marginBottom: "5px" }}
        maxLength={maxLength}
        min={min}
        max={max}
      />
      {errors && <span style={{ color: "red" }}>{errors}</span>}
    </div>
  );
}

export default AppInput;
